<template>
  <div class="part" v-if="visible">
    <div ref="part" class="part__content" @click="showDetails()">
      <img :src="`/static/images/thumbnails/${part.thumbnail}`" class="part__image"/>
      <p class="part__name" v-html="part.name"></p>
      <span class="part__remove" v-if="added">&nbsp;</span>
    </div>
    <div ref="details" class="part__details" v-if="details">
      <div class="close-button" @click="hideDetails()"><em></em></div>
      <img
        :src="`/static/images/thumbnails/${part.thumbnail}`"
        v-if="part.thumbnail"
        class="part__thumbnail"/>
      <p class="part__title" v-html="part.name"></p>
      <p class="part__description" v-html="part.description"></p>
      <div class="button part__button" @click="addOption()">Add option</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: ['part'],
  data() {
    return {
      details: false,
    };
  },
  methods: {
    ...mapActions(['addPart', 'removePart']),
    showDetails() {
      if (!this.added) {
        this.details = true;
        this.$nextTick(() => {
          const dimensions = this.$refs.part.getBoundingClientRect();
          this.$refs.details.style.left = `${dimensions.left - 50}px`;
          this.$refs.details.style.width = `${dimensions.width + 100}px`;
        });
      } else {
        this.removePart(this.part.id);
        this.details = false;
      }
    },
    hideDetails() {
      this.details = false;
    },
    addOption() {
      this.addPart(this.part.id);
      this.details = false;
    },
  },
  computed: {
    ...mapState(['configuration']),
    visible() {
      const shouldHide = this.configuration.indexOf(this.part.hide) > -1;
      const shouldShow = this.part.show ? this.configuration.indexOf(this.part.show) > -1 : true;
      return !shouldHide && shouldShow;
    },
    added() {
      return this.configuration.indexOf(this.part.id) > -1;
    },
    dimensions() {
      return this.$refs.part.getBoundingClientRect();
    },
  },
};
</script>


<style lang="scss">
@import '../styles/helpers';

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  background: #fff;

  em, em::before, em::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #6E3CBE;
    transition: all .3s;
  }

  em {
    background: none;
  }

  em::before {
    top:7px;
    transform: rotate(-45deg);
  }

  em::after {
    top:7px;
    transform: rotate(45deg);
  }

  &:hover em::before { transform: rotate(45deg); }
  &:hover em::after { transform: rotate(135deg); }
}
.part {
  cursor: pointer;
  box-sizing: border-box;
  display: inline-block;
  flex-shrink: 0;
  min-width: 200px;
  padding: 0 50px;
  position: relative;

  &__image {
    height: 120px;
    width: auto;
    display: block;
    margin: 0 auto;
    position: relative;

    &::before {
      content: " ";
      background-color: lightgray;
      border-radius: 5px;
      display: block;
      height: calc(100% + 10px);
      left: 0;
      position: absolute;
      top: -10px;
      width: 100%;
    }

    &::after {
      content: '';
      background: url('/static/svg/picture.svg') no-repeat center;
      background-size: contain;
      display: block;
      height: 120px;
      margin: 0 auto;
      opacity: .2;
      position: relative;
      width: 60px;
    }
  }

  &__details {
    position: fixed;
    background: #fff;
    padding: 36px 0 0;
    z-index: 200;
    bottom: 60px;
    box-shadow: 0 3px 8px 0 rgba($c_black, .1);
  }

  &__description {
    font-weight: 300;
    padding: 0 30px;
    margin: 0 0 36px;
  }

  &__title {
    padding: 0 30px;
    margin: 24px 0 14px;
  }

  &__thumbnail {
    height: 120px;
    width: auto;
    display: block;
    margin: 0 auto;
  }

  &__button {
    width: 100%;
  }

  &__name {
    max-width: 150px;
    text-align: center;
    font-weight: 300;
  }

  &__remove {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50px;
    height: 50px;
    background: rgba(purple, .8) url(/static/svg/remove.svg) no-repeat center;
    border-radius: 50%;
    transform: translate(-50%, -130%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Part.vue